import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

export type PlatformTenantStatus = 'ACTIVE' | 'PENDING' | 'SUSPENDED';
export type StripeConnectStatus = 'CONNECTED' | 'PENDING' | 'NOT_STARTED';

export type PlatformTenantRow = {
  id: string;
  name: string;
  slug: string;
  status: PlatformTenantStatus;
  planTier: string | null;
  createdAt: string;
  lastActivityAt: string | null;
  totalBookings: number;
  totalRevenue: number;
  platformFeeCollected: number;
  stripeConnectStatus: StripeConnectStatus;
  stripeAccountId: string | null;
  platformFeePercent: number | null;
  publicListing: boolean;
  locationCount: number;
  unitCount: number;
};

export type PlatformTenantsPage = {
  tenants: PlatformTenantRow[];
  pagination: {
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
  };
};

export type PlatformTenantsParams = {
  page: number;
  size: number;
  sortBy: string;
  sortDir: 'asc' | 'desc';
  status?: string;
  search?: string;
};

export function usePlatformTenants(params: PlatformTenantsParams) {
  return useQuery({
    queryKey: ['platform-tenants', params],
    queryFn: () => {
      const qs = new URLSearchParams();
      qs.set('page', String(params.page));
      qs.set('size', String(params.size));
      qs.set('sortBy', params.sortBy);
      qs.set('sortDir', params.sortDir);
      if (params.status) qs.set('status', params.status);
      if (params.search) qs.set('search', params.search);
      return apiClient<PlatformTenantsPage>(`/platform/tenants?${qs.toString()}`);
    },
    placeholderData: (prev) => prev,
  });
}
